
import { toArray as toArray_1, empty as empty_1, map, ofArray, exists, filter } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { int32ToString, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { ClickableImageStrip } from "../Image/ImageStrip.js";
import { empty, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ImageRole } from "../../Shared/AssignmentNotification.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { ImageUpload } from "../Image/ImageUploadDnD.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { useTranslation } from "react-i18next";
import { Table } from "../Table/Table.js";
import { append as append_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";

export function entityImageColumns(getId, entityType, images, selectedReceiverFiles, canUploadReceiverImages, componentState, t, setSelectedReceiverFiles) {
    const imagesFor = (role, entityId) => filter((image) => {
        if (equals(image.Role, role) && equals(image.EntityType, entityType)) {
            return image.EntityId === entityId;
        }
        else {
            return false;
        }
    }, images);
    const hasImages = (role_1) => exists((image_1) => {
        if (equals(image_1.Role, role_1)) {
            return equals(image_1.EntityType, entityType);
        }
        else {
            return false;
        }
    }, images);
    const imageStrip = (images_1) => createElement(ClickableImageStrip, {
        ImageClasses: ofArray(["h-14", "w-14"]),
        Images: map((image_2) => ({
            Url: image_2.ImageUrl,
        }), images_1),
    });
    return toArray(delay(() => append(hasImages(new ImageRole(0, [])) ? singleton(new ColumnDefinition$1("senderImages", "", t("assignment_notification.sender_images"), (row) => (new CellContent(2, [imageStrip(imagesFor(new ImageRole(0, []), getId(row)))])), "none", "text")) : empty(), delay(() => (canUploadReceiverImages ? singleton(new ColumnDefinition$1("receiverImages", "", t("assignment_notification.receiver_images"), (row_1) => {
        const entityId_1 = getId(row_1);
        return new CellContent(2, [createElement(ImageUpload, {
            ComponentState: componentState,
            SelectedFiles: defaultArg(tryFind([entityType, entityId_1], selectedReceiverFiles), empty_1()),
            SetSelectedFile: (files_1) => {
                setSelectedReceiverFiles([entityType, entityId_1, files_1]);
            },
        })]);
    }, "none", "text")) : (hasImages(new ImageRole(1, [])) ? singleton(new ColumnDefinition$1("receiverImages", "", t("assignment_notification.receiver_images"), (row_2) => (new CellContent(2, [imageStrip(imagesFor(new ImageRole(1, []), getId(row_2)))])), "none", "text")) : empty()))))));
}

export function ToolTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    const xs = [createElement(Table, (TableRows = toArray_1(props.Tools), {
        ColumnDefinitions: append_1([new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (row) => (new CellContent(6, [row.ImageUrl])), "none", "image"), new ColumnDefinition$1("name", "", t("general.name"), (row_1) => (new CellContent(0, [row_1.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text")], props.ExtraColumns),
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function ToolWithQuantityTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    const xs = [createElement(Table, (TableRows = toArray_1(props.ToolsWithQuantity), {
        ColumnDefinitions: append_1([new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (row) => (new CellContent(6, [row.ImageUrl])), "none", "image"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_1) => (new CellContent(0, [int32ToString(row_1.Quantity)])), "text", "text"), new ColumnDefinition$1("name", "", t("general.name"), (row_2) => (new CellContent(0, [row_2.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.InventoryNumber])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_4) => (new CellContent(0, [row_4.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_5) => (new CellContent(0, [row_5.Model])), "text", "text")], props.ExtraColumns),
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function ConsumableTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    const xs = [createElement(Table, (TableRows = toArray_1(props.Consumables), {
        ColumnDefinitions: append_1([new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (row) => (new CellContent(6, [row.ImageUrl])), "none", "image"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_1) => (new CellContent(0, [row_1.Quantity.toString()])), "none", "text"), new ColumnDefinition$1("name", "", t("general.name"), (row_2) => (new CellContent(0, [row_2.Name])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.InventoryNumber])), "text", "text")], props.ExtraColumns),
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function SetTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    const xs = [createElement(Table, (TableRows = toArray_1(props.Sets), {
        ColumnDefinitions: append_1([new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (row) => (new CellContent(6, [row.ImageUrl])), "none", "image"), new ColumnDefinition$1("name", "", t("general.name"), (row_1) => (new CellContent(0, [row_1.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text")], props.ExtraColumns),
        Controls: empty_1(),
        Options: {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))];
    return react.createElement(react.Fragment, {}, ...xs);
}

